// extracted by mini-css-extract-plugin
export var arrows = "_5n-5";
export var decrementer = "_5n-9";
export var disabled = "_5n-3";
export var error = "_5n-1";
export var hiddenText = "_5n-a";
export var incrementer = "_5n-8";
export var input = "_5n-7";
export var inputWrapper = "_5n-0";
export var leadingIcon = "_5n-b";
export var readonly = "_5n-2";
export var regular = "_5n-6";
export var small = "_5n-4";